// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaPreview_container__SOuqk","image":"MediaPreview_image__aD4us","name":"MediaPreview_name__UpG1S","vector":"MediaPreview_vector__D1wt9"};